import TRANSLATION_ACCESSIBILITY_NL from './accessibility/translation';
import TRANSLATION_BOOKING_NL from './booking/translation';
import TRANSLATION_EVENTS_NL from './events/translation';
import TRANSLATION_EXPERIENCES_NL from './experiences/translation';
import TRANSLATION_FORM_NL from './form/translation';
import TRANSLATION_LANDING_PAGES_NL from './landingPages/translation';
import TRANSLATION_RESERVE_NL from './reserve/translation';
import TRANSLATION_SIGNIN_NL from './signin/translation';
import TRANSLATION_DATES_NL from './weekdays/translation';

export default {
  ...TRANSLATION_ACCESSIBILITY_NL,
  ...TRANSLATION_BOOKING_NL,
  ...TRANSLATION_DATES_NL,
  ...TRANSLATION_EVENTS_NL,
  ...TRANSLATION_EXPERIENCES_NL,
  ...TRANSLATION_FORM_NL,
  ...TRANSLATION_LANDING_PAGES_NL,
  ...TRANSLATION_RESERVE_NL,
  ...TRANSLATION_SIGNIN_NL,
};
